import { setCategoryNum, setCategoriesData } from "./slice";

export const setCategoryId = (data) => (dispatch) => {
  dispatch(setCategoryNum(data));
};

export const setCategories = (data) => (dispatch) => {
  dispatch(setCategoriesData(data));
};
